import {
  Layout,
  Avatar,
  Tooltip,
  Button,
  Dropdown,
  message,
  Card,
  Typography
} from 'antd'
import React from 'react'
import AlloyRegistration from '../Alloy Registration/alloyRegistration'
import {
  UserOutlined,
  BellOutlined,
  QuestionCircleOutlined,
  PhoneOutlined,
  MailOutlined,
  LogoutOutlined,
  SettingOutlined,
  SafetyCertificateOutlined,
  BankOutlined
} from '@ant-design/icons'
import { useAuth } from '../../Core/Auth/AuthContext'
import { useNavigate } from 'react-router-dom'

const { Header, Content, Footer } = Layout
const { Title, Text } = Typography

const Dashboard = () => {
  const { user, logout } = useAuth()
  const navigate = useNavigate()

  const handleLogout = async () => {
    try {
      await logout()
      message.success('Logged out successfully')
      navigate('/login')
    } catch (error) {
      console.error('Logout error:', error)
      message.success('Logged out successfully') // Show success even if API call fails
      navigate('/login')
    }
  }

  const userMenuItems = [
    {
      key: 'profile',
      label: (
        <div className='flex items-center'>
          <SettingOutlined className='mr-2' />
          Profile Settings
        </div>
      ),
      onClick: () => message.info('Profile settings coming soon!')
    },
    {
      type: 'divider'
    },
    {
      key: 'logout',
      label: (
        <div className='flex items-center text-red-600'>
          <LogoutOutlined className='mr-2' />
          Logout
        </div>
      ),
      onClick: handleLogout
    }
  ]

  return (
    <Layout className='modern-layout'>
      <Header className='modern-header'>
        <div className='header-content container mx-auto flex justify-between items-center h-full'>
          <div className='brand-logo flex items-center'>
            <div className='logo-circle'>P</div>
            <div className='brand-name'>PLATI WARRANTY PORTAL</div>
          </div>

          <div className='header-actions flex items-center'>
            <div className='contact-info hidden md:flex items-center mr-6'>
              <a
                href='tel:+919915704380'
                className='flex items-center mr-4 text-gray-600 hover:text-red-600'
              >
                <PhoneOutlined className='mr-1' /> +91-99157-04380
              </a>
              <a
                href='mailto:sales@platiindia.com'
                className='flex items-center text-gray-600 hover:text-red-600'
              >
                <MailOutlined className='mr-1' /> sales@platiindia.com
              </a>
            </div>

            {/* Dealer Info Display */}
            {user && (
              <div className='dealer-header-info hidden lg:flex items-center mr-4 bg-gray-100 rounded-lg px-3 py-2'>
                <Text strong className='mr-2'>
                  {user.dealerName}
                </Text>
                <Text type='secondary' className='text-sm'>
                  ID: {user.id}
                </Text>
              </div>
            )}

            <Tooltip title='Help'>
              <QuestionCircleOutlined className='header-icon' />
            </Tooltip>
            <Tooltip title='Notifications'>
              <BellOutlined className='header-icon' />
            </Tooltip>
            <Dropdown
              menu={{ items: userMenuItems }}
              placement='bottomRight'
              trigger={['click']}
            >
              <div className='user-profile flex items-center cursor-pointer hover:bg-gray-100 rounded-lg px-3 py-2 transition-colors'>
                <span className='user-name mr-2'>
                  {user?.dealerName || user?.username || 'Dealer'}
                </span>
                <Avatar icon={<UserOutlined />} className='user-avatar' />
              </div>
            </Dropdown>
          </div>
        </div>
      </Header>

      <div className='hero-section'>
        <div className='container mx-auto px-4 py-16'>
          <div className='hero-content'>
            <h1 className='hero-title'>
              <SafetyCertificateOutlined className='mr-3' />
              Dealer Warranty Registration Portal
            </h1>
            <p className='hero-description'>
              Welcome, {user?.dealerName}! Register warranty for premium alloy
              wheels and tyres, ensuring quality and peace of mind for your
              customers.
            </p>

            {/* Dealer Info Card */}
            {user && (
              <div className='mt-6 max-w-2xl mx-auto'>
                <Card className='bg-white/90 backdrop-blur-sm border-0 shadow-lg'>
                  <div className='flex items-center justify-between'>
                    <div className='flex items-center space-x-4'>
                      <Avatar
                        size={48}
                        icon={<UserOutlined />}
                        className='bg-red-600'
                      />
                      <div>
                        <Title level={4} className='mb-1'>
                          {user.dealerName}
                        </Title>
                        <div className='flex items-center space-x-4 text-sm text-gray-600'>
                          <span>
                            <PhoneOutlined className='mr-1' />
                            {user.mobile}
                          </span>
                          {user.email && (
                            <span>
                              <MailOutlined className='mr-1' />
                              {user.email}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className='text-right'>
                      <Text strong>Dealer ID: {user.id}</Text>
                      <br />
                      <Text type='success' className='text-sm'>
                        ✓ Authenticated
                      </Text>
                    </div>
                  </div>
                </Card>
              </div>
            )}
          </div>
        </div>
      </div>

      <Content className='w-screen'>
        <div className='w-screen mx-auto'>
          <AlloyRegistration />
        </div>
      </Content>

      <Footer className='modern-footer'>
        <div className='container mx-auto px-4'>
          <div className='footer-content'>
            <div className='footer-logo'>PLATI</div>
            <div className='footer-copyright'>
              © {new Date().getFullYear()} Plati India. All rights reserved.
            </div>
            <div className='footer-links'>
              <a href='#' className='footer-link'>
                Find a Dealer
              </a>
              <a href='#' className='footer-link'>
                Become a Dealer
              </a>
              <a href='#' className='footer-link'>
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </Footer>
    </Layout>
  )
}

export default Dashboard
